import { GridData, GridParams } from '../models/grid-config.model';

export const INITIAL_GRID_PARAMS: GridParams = {
  page: 1,
  sort: [],
  pageSize: 30,
  filter: [],
  fulltext: '',
  type: '',
};

export const INITIAL_GRID_STATE: GridData<any> = {
  ...INITIAL_GRID_PARAMS,
  results: [],
  total: 0,
};
